import {
    CommunityHeader,
    CommunityInfo,
    CommunityMembers,
    FeedPost,
    ThreadPost
} from "components";
import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";
import { Link } from "react-router-dom";
import { SVG } from "ui";

const Community = () => {
    const [showInfo, setShowInfo] = useState(false);
    const [showMembers, setShowMembers] = useState(false);
    const [showAdmins, setShowAdmins] = useState(false);

    const handleOpenMembersFromHeader = () => {
        setShowInfo(false);
        setShowAdmins(false);
        setShowMembers(true);
    };

    const handleOpenMembers = (attr: "admins" | "members") => {
        setShowInfo(false);
        if (attr == "admins") {
            setShowAdmins(true);
        } else {
            setShowAdmins(false);
        }
        setShowMembers(true);
    };
    return (
        <FeedLayout pageTitle="Community">
            {!showMembers && !showInfo ? (
                <>
                    <div className=" w-full">
                        <Link
                            to="/communities"
                            className="d-flex flex-j-start flex-a-center gap-5 mb-10"
                        >
                            <SVG svg="arrow-left" size={18} />

                            <span className="momeento-p white-text black-text">
                                Back to Communities list
                            </span>
                        </Link>
                    </div>
                    <CommunityHeader
                        showInfo={showInfo}
                        setShowInfo={setShowInfo}
                        handleOpenMembersFromHeader={
                            handleOpenMembersFromHeader
                        }
                    />
                    <div className="community-posts pt-20 pb-20 mt-20">
                        <ThreadPost />
                        <FeedPost />
                    </div>
                </>
            ) : showInfo ? (
                <CommunityInfo
                    setShowInfo={setShowInfo}
                    handleOpenMembers={handleOpenMembers}
                />
            ) : (
                <CommunityMembers
                    setShowMembers={setShowMembers}
                    showAdmins={showAdmins}
                    setShowAdmins={setShowAdmins}
                />
            )}
        </FeedLayout>
    );
};

export default Community;
